import { render, staticRenderFns } from "./SignFun.vue?vue&type=template&id=fc49cbfa&scoped=true"
import script from "./SignFun.vue?vue&type=script&lang=js"
export * from "./SignFun.vue?vue&type=script&lang=js"
import style0 from "./SignFun.vue?vue&type=style&index=0&id=fc49cbfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc49cbfa",
  null
  
)

export default component.exports